<template>
  <div class="container wysh-container">
    <div class="pageTitle">售后工单</div>

    <el-form ref="form" :model="form" label-width="100px" :inline="true" class="mt20">
      <el-form-item label="工单编号:">
        <el-input v-model="form.order_no" clearable placeholder="请输入工单编号"></el-input>
      </el-form-item>
      <el-form-item label="产品名称:">
        <el-input v-model="form.product_name" clearable placeholder="请输入产品名称"></el-input>
      </el-form-item>
      <el-form-item label="工单状态:">
        <el-select v-model="form.order_status" clearable placeholder="全部状态">
          <el-option
            v-for="item in statusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">搜索</el-button>
        <el-button @click="resetSearch">重置</el-button>
      </el-form-item>
    </el-form>

    <div class="wysh-summary">
      工单总数：<span>{{ totalSize }}</span>
    </div>

    <el-table
      ref="multipleTable"
      :data="tableData"
      border
      stripe
      height="400"
      v-loading="loading"
      style="width: 100%"
    >
      <el-table-column prop="order_no" label="工单编号" width="180" fixed show-overflow-tooltip>
        <template slot-scope="scope">{{ showValue(scope.row.order_no) }}</template>
      </el-table-column>
      <el-table-column prop="product_name" label="产品名称" min-width="160" show-overflow-tooltip>
        <template slot-scope="scope">{{ showValue(scope.row.product_name) }}</template>
      </el-table-column>
      <el-table-column prop="fault_tag_name" label="故障标签" min-width="130" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ showValue(scope.row.fault_tag_name || scope.row.fault_category) }}
        </template>
      </el-table-column>
      <el-table-column prop="user_name" label="用户名称" min-width="120" show-overflow-tooltip>
        <template slot-scope="scope">{{ showValue(scope.row.user_name) }}</template>
      </el-table-column>
      <el-table-column prop="user_phone" label="用户手机" min-width="130" show-overflow-tooltip>
        <template slot-scope="scope">{{ showValue(scope.row.user_phone) }}</template>
      </el-table-column>
      <el-table-column prop="order_status" label="工单状态" width="110">
        <template slot-scope="scope">
          <el-tag :type="statusTagType(scope.row.order_status)">
            {{ scope.row.order_status_text || statusText(scope.row.order_status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="create_time" label="创建时间" width="170" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ timeText(scope.row.create_time, scope.row.create_time_text) || "-" }}
        </template>
      </el-table-column>
      <el-table-column prop="update_time" label="更新时间" width="170" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ timeText(scope.row.update_time, scope.row.update_time_text) || "-" }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="openDetail(scope.row)">查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      style="margin: 20px 0"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageNo"
      :page-sizes="[20, 50, 100, 200]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalSize"
    ></el-pagination>

    <el-dialog
      title="工单详情"
      :visible.sync="detailVisible"
      width="820px"
      :close-on-click-modal="false"
    >
      <div class="wysh-detail" v-loading="detailLoading">
        <div v-if="detailData">
          <div class="detail-section">
            <div class="section-title">用户信息</div>
            <el-row>
              <el-col :span="12"><DetailItem label="用户名称" :value="detailData.user_name" /></el-col>
              <el-col :span="12"><DetailItem label="用户手机" :value="detailData.user_phone" /></el-col>
              <el-col :span="24"><DetailItem label="用户地区" :value="regionText(detailData)" /></el-col>
              <el-col :span="24"><DetailItem label="详细地址" :value="detailData.detailed_address" /></el-col>
            </el-row>
          </div>

          <div class="detail-section">
            <div class="section-title">产品信息</div>
            <el-row>
              <el-col :span="12"><DetailItem label="产品名称" :value="detailData.product_name" /></el-col>
              <el-col :span="12"><DetailItem label="产品编号" :value="detailData.product_number" /></el-col>
              <el-col :span="12"><DetailItem label="产品批次" :value="detailData.batch" /></el-col>
              <el-col :span="12"><DetailItem label="防伪码" :value="detailData.fwcode" /></el-col>
            </el-row>
          </div>

          <div class="detail-section">
            <div class="section-title">故障信息</div>
            <el-row>
              <el-col :span="12">
                <DetailItem
                  label="故障标签"
                  :value="detailData.fault_tag_name || detailData.fault_category"
                />
              </el-col>
              <el-col :span="24"><DetailItem label="故障描述" :value="detailData.fault_desc" /></el-col>
            </el-row>
            <div class="detail-item image-item" v-if="detailImages.length">
              <span class="detail-label">故障图片：</span>
              <div class="image-list">
                <img
                  v-for="(image, index) in detailImages"
                  :key="image + index"
                  :src="image"
                  alt="故障图片"
                  @click="previewImage(image)"
                />
              </div>
            </div>
          </div>

          <div class="detail-section">
            <div class="section-title">工单信息</div>
            <el-row>
              <el-col :span="12"><DetailItem label="工单编号" :value="detailData.order_no" /></el-col>
              <el-col :span="12">
                <div class="detail-item">
                  <span class="detail-label">工单状态：</span>
                  <span class="detail-value">
                    <el-tag :type="statusTagType(detailData.order_status)">
                      {{ detailData.order_status_text || statusText(detailData.order_status) }}
                    </el-tag>
                  </span>
                </div>
              </el-col>
              <el-col :span="12"><DetailItem label="维修类型" :value="repairTypeText(detailData.repair_type)" /></el-col>
              <el-col :span="12"><DetailItem label="派单方式" :value="assignTypeText(detailData.assign_type)" /></el-col>
              <el-col :span="12"><DetailItem label="经销商编号" :value="detailData.dealer_sn" /></el-col>
              <el-col :span="12"><DetailItem label="质保卡编号" :value="detailData.warranties_card_no" /></el-col>
              <el-col :span="12"><DetailItem label="是否在质保期" :value="warrantyText(detailData.is_warranty)" /></el-col>
              <el-col :span="12">
                <DetailItem label="创建时间" :value="timeText(detailData.create_time, detailData.create_time_text)" />
              </el-col>
              <el-col :span="12">
                <DetailItem label="更新时间" :value="timeText(detailData.update_time, detailData.update_time_text)" />
              </el-col>
              <el-col :span="24"><DetailItem label="备注" :value="detailData.remark" /></el-col>
            </el-row>
          </div>

          <div class="detail-section">
            <div class="section-title">维修信息</div>
            <el-row>
              <el-col :span="12"><DetailItem label="维修员 ID" :value="detailData.repairer_id" /></el-col>
              <el-col :span="12"><DetailItem label="维修员电话" :value="detailData.repairer_phone" /></el-col>
              <el-col :span="24"><DetailItem label="维修员 OpenID" :value="detailData.repairer_open_id" /></el-col>
              <el-col :span="24"><DetailItem label="维修结果" :value="detailData.repair_result" /></el-col>
            </el-row>
          </div>
        </div>
        <div v-else-if="!detailLoading" class="empty-detail">工单不存在或已删除</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailVisible = false">关闭</el-button>
        <el-button
          type="primary"
          :loading="submitting"
          v-if="canComplete"
          @click="openComplete"
        >完成工单</el-button>
        <el-button
          type="danger"
          :loading="submitting"
          v-if="canCancel"
          @click="openCancel"
        >取消工单</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="完成工单"
      :visible.sync="completeVisible"
      width="520px"
      :close-on-click-modal="false"
    >
      <el-input
        type="textarea"
        :rows="5"
        maxlength="2000"
        placeholder="请输入维修结果"
        v-model="repairResult"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button :disabled="submitting" @click="completeVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="completeOrder">确认完成</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="取消工单"
      :visible.sync="cancelVisible"
      width="520px"
      :close-on-click-modal="false"
    >
      <el-input
        type="textarea"
        :rows="5"
        maxlength="2000"
        placeholder="请输入取消原因"
        v-model="cancelReason"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button :disabled="submitting" @click="cancelVisible = false">返回</el-button>
        <el-button type="danger" :loading="submitting" @click="cancelOrder">确认取消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="图片预览" :visible.sync="previewVisible" width="620px">
      <div class="preview-box">
        <img :src="previewUrl" alt="故障图片预览" v-if="previewUrl" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
var DetailItem = {
  name: "DetailItem",
  props: {
    label: { type: String, default: "" },
    value: { default: "" },
  },
  methods: {
    showValue: function(value) {
      if (value === null || typeof value === "undefined" || value === "") {
        return "-";
      }
      return String(value);
    },
  },
  render: function(h) {
    return h("div", { class: "detail-item" }, [
      h("span", { class: "detail-label" }, [this.label + "："]),
      h("span", { class: "detail-value" }, [this.showValue(this.value)]),
    ]);
  },
};

export default {
  name: "wysh",
  components: {
    DetailItem: DetailItem,
  },
  data() {
    return {
      form: {
        order_no: "",
        product_name: "",
        order_status: "",
      },
      statusOptions: [
        { label: "全部状态", value: "" },
        { label: "已派单", value: "2" },
        { label: "维修中", value: "3" },
        { label: "已完成", value: "4" },
        { label: "已取消", value: "5" },
      ],
      tableData: [],
      loading: false,
      pageNo: 1,
      pageSize: 20,
      totalSize: 0,
      detailVisible: false,
      detailLoading: false,
      detailData: null,
      completeVisible: false,
      cancelVisible: false,
      submitting: false,
      repairResult: "",
      cancelReason: "",
      previewVisible: false,
      previewUrl: "",
    };
  },
  computed: {
    detailImages() {
      return this.parseImages(this.detailData && this.detailData.fault_images);
    },
    canCancel() {
      return !!this.detailData && [2, 3].indexOf(Number(this.detailData.order_status)) !== -1;
    },
    canComplete() {
      return !!this.detailData && [2, 3].indexOf(Number(this.detailData.order_status)) !== -1;
    },
  },
  created() {
    this.onSearch();
  },
  methods: {
    requestSuccess(response) {
      return !response || typeof response.code === "undefined" || response.code === 1 || response.code === 200;
    },
    normalizeList(response) {
      var payload = response && response.data ? response.data : {};
      if (payload && payload.data && !payload.list && !Array.isArray(payload.data)) {
        payload = payload.data;
      }

      var list = [];
      if (payload && Array.isArray(payload.list)) {
        list = payload.list;
      } else if (payload && Array.isArray(payload.data)) {
        list = payload.data;
      } else if (response && Array.isArray(response.data)) {
        list = response.data;
      }

      var total = 0;
      if (payload && payload.total) {
        total = Number(payload.total);
      } else if (payload && payload.meta && payload.meta.total) {
        total = Number(payload.meta.total);
      } else if (response && response.meta && response.meta.total) {
        total = Number(response.meta.total);
      } else {
        total = list.length;
      }

      return {
        list: list,
        total: total,
      };
    },
    normalizeDetail(response) {
      var payload = response && response.data ? response.data : null;
      if (payload && payload.data) {
        return payload.data;
      }
      return payload;
    },
    onSearch() {
      this.pageNo = 1;
      this.getList();
    },
    resetSearch() {
      this.form = {
        order_no: "",
        product_name: "",
        order_status: "",
      };
      this.onSearch();
    },
    getList() {
      this.loading = true;
      this.$get("logistics_1", "/wysh/orders", {
        page: this.pageNo,
        limit: this.pageSize,
        per_page: this.pageSize,
        order_no: this.form.order_no,
        product_name: this.form.product_name,
        order_status: this.form.order_status,
      })
        .then((response) => {
          if (!this.requestSuccess(response)) {
            throw new Error((response && (response.message || response.msg)) || "工单加载失败");
          }
          var result = this.normalizeList(response);
          this.tableData = result.list;
          this.totalSize = result.total;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: this.errorMessage(error, "工单加载失败"),
          });
        })
        .then(() => {
          this.loading = false;
        });
    },
    openDetail(row) {
      if (!row || !row.id) {
        this.$message({ type: "warning", message: "缺少工单 ID" });
        return;
      }
      this.detailVisible = true;
      this.detailData = null;
      this.detailLoading = true;
      this.$get("logistics_1", "/wysh/orders/detail", { id: row.id })
        .then((response) => {
          if (!this.requestSuccess(response)) {
            throw new Error((response && (response.message || response.msg)) || "工单详情加载失败");
          }
          this.detailData = this.normalizeDetail(response);
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: this.errorMessage(error, "工单详情加载失败"),
          });
        })
        .then(() => {
          this.detailLoading = false;
        });
    },
    openComplete() {
      this.repairResult = "";
      this.completeVisible = true;
    },
    openCancel() {
      this.cancelReason = "";
      this.cancelVisible = true;
    },
    completeOrder() {
      if (this.repairResult === "") {
        this.$message({ type: "warning", message: "请输入维修结果" });
        return;
      }
      this.submitAction("complete", { repair_result: this.repairResult }, "完成工单");
    },
    cancelOrder() {
      if (this.cancelReason === "") {
        this.$message({ type: "warning", message: "请输入取消原因" });
        return;
      }
      this.submitAction("cancel", { cancel_reason: this.cancelReason }, "取消工单");
    },
    submitAction(action, payload, successText) {
      if (this.submitting || !this.detailData || !this.detailData.id) {
        return;
      }
      this.submitting = true;
      payload.id = this.detailData.id;
      this.$post("logistics_1", "/wysh/orders/" + action, payload)
        .then((response) => {
          if (!this.requestSuccess(response)) {
            throw new Error((response && (response.message || response.msg)) || successText + "失败");
          }
          this.$message({ type: "success", message: successText + "成功" });
          this.completeVisible = false;
          this.cancelVisible = false;
          this.refreshDetailAndList();
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: this.errorMessage(error, successText + "失败"),
          });
        })
        .then(() => {
          this.submitting = false;
        });
    },
    refreshDetailAndList() {
      if (this.detailData && this.detailData.id) {
        this.openDetail({ id: this.detailData.id });
      }
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNo = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getList();
    },
    errorMessage(error, fallback) {
      if (error && error.response && error.response.data) {
        return error.response.data.message || error.response.data.msg || fallback;
      }
      return (error && (error.message || error.msg)) || fallback;
    },
    showValue(value) {
      if (value === null || typeof value === "undefined" || value === "") {
        return "-";
      }
      return value;
    },
    statusText(status) {
      var names = {
        1: "待派单",
        2: "已派单",
        3: "维修中",
        4: "已完成",
        5: "已取消",
      };
      return names[Number(status)] || "未知";
    },
    statusTagType(status) {
      var types = {
        1: "danger",
        2: "",
        3: "warning",
        4: "success",
        5: "info",
      };
      return types[Number(status)] || "info";
    },
    repairTypeText(value) {
      var names = {
        0: "未分配",
        1: "总部维修",
        2: "经销商维修",
        3: "门店维修",
      };
      return names[Number(value)] || "未分配";
    },
    assignTypeText(value) {
      var names = { 1: "手动派单", 2: "自动派单" };
      return names[Number(value)] || "-";
    },
    warrantyText(value) {
      if (value === null || typeof value === "undefined" || value === "") {
        return "-";
      }
      return Number(value) === 1 ? "是" : "否";
    },
    regionText(order) {
      var values = [order && order.province, order && order.city, order && (order.district || order.area)];
      return values
        .filter(function(value) {
          return value !== null && typeof value !== "undefined" && value !== "";
        })
        .join(" ");
    },
    timeText(timestamp, formatted) {
      if (formatted) {
        return formatted;
      }
      if (!timestamp) {
        return "";
      }
      if (typeof timestamp === "string" && timestamp.indexOf("-") !== -1) {
        return timestamp;
      }
      var number = Number(timestamp);
      if (String(timestamp).length === 13) {
        number = number / 1000;
      }
      var date = new Date(number * 1000);
      if (isNaN(date.getTime())) {
        return "";
      }
      var pad = function(value) {
        return value < 10 ? "0" + value : String(value);
      };
      return (
        date.getFullYear() +
        "-" +
        pad(date.getMonth() + 1) +
        "-" +
        pad(date.getDate()) +
        " " +
        pad(date.getHours()) +
        ":" +
        pad(date.getMinutes()) +
        ":" +
        pad(date.getSeconds())
      );
    },
    parseImages(source) {
      if (typeof source === "string") {
        try {
          source = JSON.parse(source);
        } catch (error) {
          source = source ? [source] : [];
        }
      }
      if (!Array.isArray(source)) {
        return [];
      }
      return source.filter(function(url) {
        return typeof url === "string" && (/^https?:\/\//i.test(url) || url.charAt(0) === "/");
      });
    },
    previewImage(url) {
      this.previewUrl = url;
      this.previewVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.wysh-container {
  .wysh-summary {
    margin-bottom: 10px;
    color: #333;

    span {
      color: red;
      margin-right: 10px;
    }
  }

  .wysh-detail {
    min-height: 160px;
  }

  .detail-section {
    margin-bottom: 14px;
    border: 1px solid #ebeef5;
  }

  .section-title {
    padding: 10px 14px;
    color: #303133;
    font-weight: 600;
    background-color: #f5f7fa;
    border-bottom: 1px solid #ebeef5;
  }

  .detail-item {
    display: flex;
    min-height: 38px;
    padding: 8px 14px;
    line-height: 22px;
    box-sizing: border-box;
  }

  .detail-label {
    flex: 0 0 105px;
    color: #909399;
    text-align: right;
  }

  .detail-value {
    flex: 1;
    min-width: 0;
    color: #303133;
    text-align: left;
    white-space: pre-wrap;
    word-break: break-all;
  }

  .image-item {
    border-top: 1px solid #ebeef5;
  }

  .image-list {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
  }

  .image-list img {
    width: 80px;
    height: 80px;
    margin: 0 10px 10px 0;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    object-fit: cover;
    cursor: pointer;
  }

  .empty-detail {
    padding: 60px 0;
    color: #909399;
    text-align: center;
  }

  .preview-box {
    text-align: center;
  }

  .preview-box img {
    max-width: 100%;
    max-height: 70vh;
  }
}
</style>
